import styled, { css } from 'styled-components';

const TagsList = styled.ul`
  display: flex;
  padding: 5vh 0;
  margin: 0;
  list-style: none;
  flex-wrap: wrap;
  border: 2px dashed transparent;

  ${(p) => p.empty && css`
    position: relative;
    border-color: ${(p) => p.theme.colors.grays.light};
    border-radius: 0.5em;
    :after {
      content: 'None Selected';
      color: ${(p) => p.theme.typography.colors.muted};
      position: absolute;
      top: 1vh;
      left: 1vh;
    }
  `}
`;

export default TagsList;
